import React, { useEffect, useMemo, useState } from 'react';
import { Catalogue } from '../../pages';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import OrderController from '../../controllers/OrderController';
import { businessStore, ordersStore } from '../../stores';
import { toJS } from 'mobx';
import { useLocation } from 'react-router-dom';

const CatalogueContainer = () => {
	const { search } = useLocation();

	const storeName = search.split('=')?.[1];

	const [limit, setLimit] = useState(50);
	const [filterQuery, setFilterQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');

	const designsTableQuery = useMemo(() => {
		let query = `offset=${currentPage + 1}&limit=${limit}&storeFrontName=${storeName}`;

		if (searchQuery) {
			query += `&search=${searchQuery}`;
		}

		return query;
	}, [currentPage, limit, storeName, searchQuery]);

	const { isLoading, data, isFetching } = OrderController.useGetDesigns(
		designsTableQuery,
		filterQuery
	);

	const onLimitChange = limit => {
		setLimit(limit);
		setCurrentPage(0);
	};

	const navigate = useNavigate();

	const goToViewMoreDesign = () => {
		navigate(constant.Routes.ViewMoreDesign);
	};

	return (
		<Catalogue
			goToViewMoreDesign={goToViewMoreDesign}
			data={data}
			isFetching={isFetching}
			isLoading={isLoading}
			limit={limit}
			onLimitChange={onLimitChange}
			currentPage={currentPage}
			setCurrentPage={setCurrentPage}
			setSearchQuery={setSearchQuery}
		/>
	);
};
export default CatalogueContainer;
